import React from "react";
import { FaAngleDoubleDown } from "../shared/icons";

const DoubleDownArrow = () => {
  return (
    <div className="chDoubleDownArrow">
      <FaAngleDoubleDown />
    </div>
  );
};

export default DoubleDownArrow;
